import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OnLoadImageDirective } from "./on-load-image.directive";

@NgModule({
	declarations: [OnLoadImageDirective],
	imports: [CommonModule],
	exports: [OnLoadImageDirective],
})
export class OnLoadImageDirectiveModule {}
